import React, { useContext } from 'react'
import { MemberGlobalStyles } from 'spa/member/styles/GlobalStyles'
import { Flash } from '../../../../javascripts/layouts/v2/Flash'
import FlashType from 'javascripts/layouts/v2/FlashType'
import Footer from 'spa/member/components/Footer/Index'
import StyledHeader from 'spa/member/components/Header/Index'
import { SessionContext } from 'spa/App';

interface MemberLayoutProps {
  flash: FlashType;
  children: React.ReactNode;
}

export const StyledMemberLayout: React.FC<MemberLayoutProps> = (props: MemberLayoutProps) => {
  const session = useContext(SessionContext)

  return (
    <>
      <StyledHeader session={session} />
      {props.flash ? <Flash flash={props.flash} /> : null}
      <MemberGlobalStyles />
      {props.children}
      <Footer />
    </>
  )
}
